import React from 'react';
import { Button, Typography, Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import electricImage from '../assets/404_electric.gif';
const isUnsubscribe = window.location.pathname === '/unsubscribe';
export const NoPageFound = props => {
    return (
        <div style={{ display: isUnsubscribe ? 'none' : 'block' }}>
            <Grid
                container
                spacing={2}
                directon="row"
                justifyContent="space-around"
                alignItems="center"
            >
                <Grid item xs={12} md={10}>
                    <Box className="padding" align="center" justify="center">
                        <Box pad="small">
                            <Typography variant="h1">
                                This Page Does Not Exist
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <img
                                alt="404 - No Page Exists"
                                fit="cover"
                                src={electricImage}
                                style={{ width: '100%', maxHeight: '550px' }}
                            />
                        </Box>
                        <Box>
                            <Typography
                                variant="subtitle2"
                                style={{ paddingBottom: '20px' }}
                            >
                                Sorry, It seems you have found a page that
                                doesn't exist
                            </Typography>
                        </Box>
                        <Box pad="medium">
                            <Link to="/">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    margin="small"
                                >
                                    Back to main page
                                </Button>
                            </Link>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default NoPageFound;
